// extracted by mini-css-extract-plugin
export default {"layout":"CourseLayout_layout__UYv6l","main":"CourseLayout_main__WRPp1","content":"CourseLayout_content__79mRs"};